/**
 * After `PUT /billing/v2/subscription` the charge can still need SCA / 3D Secure
 * verification (or, for a change to an already-active plan, be held as a
 * `pending_update` awaiting confirmation). We do NOT handle that inline in
 * checkout - it is driven entirely by the PaymentVerificationBanner on the
 * billing screen (one predictable path: inline confirm when possible, Stripe's
 * hosted invoice page otherwise).
 *
 * Returns true when the subscription response indicates a payment still needs the
 * customer's action and the banner should take over.
 */
export const subscriptionNeedsVerification = (subscription: any): boolean => {
    if (!subscription) return false;

    const hasPendingUpdate =
        !!subscription.pendingUpdateExpiresAt &&
        new Date(subscription.pendingUpdateExpiresAt).getTime() > Date.now();

    return (
        subscription.paymentVerificationRequired === true ||
        hasPendingUpdate ||
        ['past_due', 'incomplete'].includes(subscription.status)
    );
};
